export default {
	label: 'Meetme vastutavad ja maksumus',
	changes: 'Muudatusi',
	method: 'meede | meedet',
	changesTooltip: 'Muudatusi päevade jooksul',
	goToMethodsPage: 'Vajuta meetmete filtreerimiseks',
	responsibles: 'Vastutajad',
	serviceProviders: 'Teenusepakkujad',
	goToOverdueMethods: 'Vajuta üle tähtaja meetmete filtreerimiseks',
}
